module.exports = __webpack_public_path__ + "img/发布部门.5ce3b6d0.png";